<template>
  <el-dialog 
    :title="type === 'add' ? '新增客户' : '编辑客户信息'"
    :visible="visible"
    width="600px"
    :close-on-click-modal="false"
    center
     @close="closeDialog()"
  >
    <el-form 
      :model="form" 
      :rules="formRules" 
      ref="customerForm"
      label-width="120px"
      label-position="right"
    >
      <el-form-item label="客户姓名" prop="name">
        <el-input 
          v-model="form.name" 
          placeholder="请输入客户姓名"
          clearable
        ></el-input>
      </el-form-item>
      
      <el-form-item label="手机号码" prop="phone">
        <el-input 
          v-model="form.phone" 
          placeholder="请输入手机号码"
          clearable
        ></el-input>
      </el-form-item>
      
      <el-form-item label="备注信息" prop="remark">
        <el-input 
          type="textarea" 
          v-model="form.remark" 
          placeholder="请输入客户备注信息"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog()">取 消</el-button>
      <el-button 
        type="primary" 
        @click="submitForm"
      >
        {{ type === 'add' ? '确 定 添 加' : '保 存 修 改' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CustomerFormDialog',
  props: {
    visible: Boolean,
    type: String,
    form: Object
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入有效的手机号码'));
      } else {
        callback();
      }
    };
    
    return {
      formRules: {
        name: [
          { required: true, message: '客户姓名不能为空', trigger: 'blur' },
          { min: 2, max: 12, message: '姓名长度在2到12个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        openid: [
          { min: 10, max: 40, message: 'OpenID长度在10到40个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    },
    submitForm() {
      this.$refs.customerForm.validate(valid => {
        if (valid) {
          this.$emit('submit');
        } else {
          this.$message.warning('请填写正确的客户信息');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>